import PaginatedList from "@theme/paginated-list";

/**
 * Custom element for paginated collection/search results.
 * Extends PaginatedList for infinite scroll support.
 *
 * @attr {string} section-id - The Shopify section ID
 * @attr {string} infinite-scroll - "true" | "false"
 */
export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("initialized", "");
  }
}

if (!customElements.get("results-list")) {
  customElements.define("results-list", ResultsList);
}
